<template>
  <div name="hres6oe-check-in-out" class="checkin-google-map">
    <div class="place-box">
      <div class="select-place-box with-scroll">
        <div :key="index"
            v-for="(dataRow, index) in workPlaceData"
            class="select-place"
            @click="checkedPlace(index)" >
          <div class="color-icon _bg-red">
            <i class="fa fa-building -icon-building"></i>
          </div>
          <div class="building-detail">
            <div class="building-name">
              {{dataRow.title}}
            </div>
            <div class="building-location">
              {{dataRow.address}}
            </div>
          </div>
          <i v-if="(lastCheckIn.codcust === dataRow.codcust && lastCheckIn.flg_inout === 'I' && lastCheckIn === 'N') || index === selected" class="ion-checkmark check-place" aria-hidden="true"></i>
        </div>
        <input data-toggle="modal" data-target="#hres6oe-cust-latlng" type="hidden" ref="custNewLatLngPopup">
      </div>
      <div class="select-place-box">
        <div class="select-place" @click="callCustNewLatLngList()">
          <div class="color-icon _bg-blue">
            <i class="fa fa-building -icon-building"></i>
          </div>
          <div class="building-detail">
            <div class="other">
              {{this.custNewLatLngSelected.length > 0 ? this.custNewLatLngSelected[0].namcust : label['HRES6OEC2']['70']}}
            </div>
          </div>
            <!-- {{label['HRES6OEC2']['10']}} -->
          <i v-if="workPlaceData.length + 2 === selected" class="ion-checkmark check-place" aria-hidden="true"></i>
        </div>
        <cust-new-lat-lng :labels="label"
                          :data="placeNewLatLng"
                          :flgClearFilterLocation="flgClearFilterLocation"
                          :holdFilterLocation="holdFilterLocation"
                          :placeNewLatLngColumns="placeNewLatLngColumns"
                          :setCustNewLatLngSelected="setCustNewLatLngSelected"
                          :receivedCheckInPlaceNoLocation="receivedCheckInPlaceNoLocation" />
        <div class="select-place" @click="checkedPlace(workPlaceData.length + 1)">
          <div class="color-icon">
            <i class="fa fa-building -icon-building"></i>
          </div>
          <div class="building-detail">
            <div class="other">
              {{label['HRES6OEC2']['10']}}
            </div>
          </div>
            <!-- {{label['HRES6OEC2']['10']}} -->
          <i v-if="workPlaceData.length + 1 === selected" class="ion-checkmark check-place" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="checkin-input-box">
      <div v-if="(lastCheckIn.typplace === '3' && lastCheckIn.flg_inout === 'I' && isLastChkInInArea) || workPlaceData.length + 1 === selected">
        <div class="input-group">
          <div class="label">{{label['HRES6OEC2']['40']}} <span class="text-red">*</span></div>
          <input  v-model="detail.new_namcust"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="new_namcust"
                  name="input"
                  maxlength="45" 
                  :has-error="errors.has('new_namcust')" />
          <div class="validator-text -error" v-show="errors.has('new_namcust')">{{errors.first('new_namcust')}}</div>
        </div>
        <div class="input-group">
          <div class="label">{{label['HRES6OEC2']['50']}} <span class="text-red">*</span></div>
          <input  v-model="detail.namcontact"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="namcontact"
                  name="input"
                  maxlength="45" 
                  :has-error="errors.has('namcontact')" />
          <div class="validator-text -error" v-show="errors.has('namcontact')">{{errors.first('namcontact')}}</div>
        </div>
        <div class="input-group">
          <div class="label">{{label['HRES6OEC2']['60']}} <span class="text-red">*</span></div>
          <input  v-model="detail.phone"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="phone"
                  name="input"
                  maxlength="30" 
                  :has-error="errors.has('phone')" />
          <div class="validator-text -error" v-show="errors.has('phone')">{{errors.first('phone')}}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="label">{{label['HRES6OEC2']['20']}} <span class="text-red">*</span></div>
        <hrms-dropdown  v-model="detail.codreason"
                        :options="dropdowns"
                        v-validate="'required'"
                        data-vv-value-path="inputValue"
                        data-vv-name="codreason"
                        :has-error="errors.has('codreason')" />
        <div class="validator-text -error" v-show="errors.has('codreason')">{{errors.first('codreason')}}</div>
      </div>
      <div class="input-group">
        <div class="label">{{label['HRES6OEC2']['30']}} <span class="text-red">*</span></div>
        <textarea v-model="detail.activity"
                  class="normal-input"
                  style="height: 200px;"
                  type="text"
                  maxlength="500"
                  v-validate="'required|max:500'"
                  data-vv-name="activity"
                  name="input"
                  :has-error="errors.has('activity')" ></textarea>
        <div class="validator-text -error" v-show="errors.has('activity')">{{errors.first('activity')}}</div>
        <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div>
      </div>
      <div class="input-group">
        <div class="label"><i class="fa fa-camera"></i> {{label['HRES6OEC2']['80']}} <span class="text-red">*</span></div>
        <div v-if="detail.filenamei && pathImage" class="checkin-image">
          <img :src="pathImage + detail.filenamei">
        </div>
        <div v-if="this.typButton === 'O'">
          <hrms-dropzone  v-model='detail.filenamei'
                          :fileNameQuery="detail.filenamei"
                          :prefixFileName="currentUser.p_codempid"
                          :capture="'HAF'"
                          :flgToggle="detailDisp"
                          :name="'imageChkIn'"
                          :maxFileSizeInMB="20"
                          :acceptedFileTypes="'image/*'"
                          :resizeWidth="600"
                          v-validate="'required'"
                          data-vv-value-path="inputValue"
                          data-vv-name="filenamei"
                          :has-error="errors.has('filenamei')"
                          ref="hrmsDropzoneChkIn" />
          <div class="validator-text -error" v-show="errors.has('filenamei')">{{errors.first('filenamei')}}</div>
        </div>
      </div>
      <div v-if="this.typButton === 'I'">
        <div class="input-group">
          <div class="label"><i class="fa fa-camera"></i> {{label['HRES6OEC2']['90']}} <span class="text-red">*</span></div>
          <div v-if="detail.filenameo && pathImage" class="checkin-image">
            <img :src="pathImage + detail.filenameo">
          </div>
          <hrms-dropzone  v-model='detail.filenameo'
                          :fileNameQuery="detail.filenameo"
                          :prefixFileName="currentUser.p_codempid"
                          :capture="'HAF'"
                          :flgToggle="detailDisp"
                          :name="'imageChkOut'"
                          :maxFileSizeInMB="20"
                          :acceptedFileTypes="'image/*'"
                          :resizeWidth="600"
                          v-validate="'required'"
                          data-vv-value-path="inputValue"
                          data-vv-name="filenameo"
                          :has-error="errors.has('filenameo')"
                          ref="hrmsDropzoneChkOut" />
          <div class="validator-text -error" v-show="errors.has('filenameo')">{{errors.first('filenameo')}}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="button-md" :class="(typButton === 'I' ? '_bg-orange' : '_bg-green') + ' ' + (pcDisp ? '' : '-mobile')" @click="callSave()">{{typButton === 'I' ? 'Check Out' : 'Check In'}}</div>
        <div class="button-md _bg-grey" :class="pcDisp ? '' : '-mobile'" @click="callBack()">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
import custNewLatLng from 'components/hres6oe/custNewLatLng'
import { constLabels } from 'assets/js/constLabels.js'
import swal from 'sweetalert'

export default {
  name: 'hres6oe-check-in-out',
  props: [
    'label',
    'toggle',
    'dropdowns',
    'lastCheckIn',
    'currentUser',
    'saveCheckIn',
    'placeNewLatLng',
    'placeNewLatLngColumns',
    'setCustNewLatLngSelected',
    'setPlaceNewLatLng',
    'custNewLatLngSelected',
    'workPlaceData',
    'center',
    'pathImage',
    'detailDisp',
    'pcDisp',
    'scrollTop',
    'receivedCheckInPlaceNoLocation',
    'flgClearFilterLocation',
    'holdFilterLocation',
    'selectedCompanyCheckin',
    'setSelectedCompanyCheckin'
  ],
  data () {
    return {
      app: this.$root.$children[0],
      detail: {
        new_namcust: '',
        namcontact: '',
        phone: '',
        codreason: '',
        activity: '',
        typplace: '1',
        filenamei: '',
        filenameo: '',
        isLastChkInInArea: false
      },
      selected: this.selectedCompanyCheckin,
      typButton: 'O'
    }
  },
  watch: {
    selectedCompanyCheckin () {
      this.selected = this.selectedCompanyCheckin
    },
    selected () {
      this.setSelectedCompanyCheckin(this.selected)
    },
    workPlaceData () {
      this.checkCustSelect()
    },
    'lastCheckIn' () {
      this.checkCustSelect()
    },
    custNewLatLngSelected () {
      if (this.custNewLatLngSelected.length > 0) {
        this.selected = this.workPlaceData.length + 2
        this.detail.typplace = '2'
        this.detail.new_namcust = ''
        this.detail.namcontact = ''
        this.detail.phone = ''
      }
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    checkedPlace (index) {
      if (this.typButton === 'O') {
        this.selected = index
        this.detail.new_namcust = ''
        this.detail.namcontact = ''
        this.detail.phone = ''
      }
      if (this.workPlaceData.length + 1 === index) {
        this.detail.typplace = '3'
      } else {
        this.detail.typplace = '1'
      }
      this.setCustNewLatLngSelected([])
    },
    checkCustSelect () {
      this.selected = this.workPlaceData.map(dataMap => {
        return dataMap.codcust
      }).indexOf(this.lastCheckIn.codcust)

      if (this.lastCheckIn.flg_inout === 'I' && this.selected >= 0 && this.lastCheckIn.o_dtework === 'N') {
        this.typButton = 'I'
        this.detail = Object.assign({}, this.lastCheckIn)
        this.isLastChkInInArea = true
      } else {
        this.typButton = 'O'
        this.detail = {
          new_namcust: '',
          namcontact: '',
          phone: '',
          codreason: '',
          activity: '',
          typplace: '1',
          filenamei: '',
          filenameo: ''
        }
        this.selected = this.selectedCompanyCheckin
        this.isLastChkInInArea = false
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    callCustNewLatLngList () {
      if (this.typButton === 'O') {
        this.$refs.custNewLatLngPopup.click()
      }
    },
    callBack () {
      this.toggle('place')
      this.selected = -1
      if (this.lastCheckIn.flg_inout !== 'I' || this.typButton === 'O') {
        this.detail = {
          new_namcust: '',
          namcontact: '',
          phone: '',
          codreason: '',
          activity: '',
          typplace: '1',
          filenamei: '',
          filenameo: ''
        }
      }
      this.setCustNewLatLngSelected([])
      this.scrollTop()
    },
    paramSave () {
      let lat = 0
      let lng = 0
      let codcust = ''
      if (this.detail.typplace === '2' && this.typButton === 'O') {
        lat = this.center.lat
        lng = this.center.lng
        codcust = this.custNewLatLngSelected[0].codcust
      } else {
        if (this.detail.new_namcust.trim().length > 0) {
          lat = this.center.lat
          lng = this.center.lng
          codcust = this.typButton === 'I' ? this.workPlaceData[this.selected].codcust : '9999999999'
        } else {
          lat = this.center.lat + ''
          lng = this.center.lng + ''
          codcust = this.workPlaceData[this.selected].codcust
        }
      }
      return {
        // flgchkin: this.lastCheckIn.flg_inout === 'I' ? 'O' : 'I',
        flgchkin: this.typButton === 'I' ? 'O' : 'I',
        codempid: this.currentUser.p_codempid,
        // codempid: '16010', // for demo
        codcust: codcust,
        typplace: this.detail.typplace,
        // codjob: this.,
        codreason: this.detail.codreason,
        activity: this.detail.activity,
        latitude: lat,
        longitude: lng,
        filenamei: this.detail.filenamei,
        filenameo: this.detail.filenameo,
        new_namcust: this.detail.new_namcust, // .trim(),
        namcontact: this.detail.namcontact,
        phone: this.detail.phone,
        zipcode: '',
        adrcust: ''
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selected < 0) {
            swal({title: '', text: constLabels('HR2046'), html: true, type: 'error'})
          } else {
            this.saveCheckIn({saveParams: this.paramSave(), searchParams: {codempid: this.currentUser.p_codempid}})
          // this.saveCheckIn({saveParams: this.paramSave(), searchParams: '16010'}) // for demo
            this.scrollTop()
          }
        }
      })
    }
  },
  components: {
    custNewLatLng
  }
}
</script>



// WEBPACK FOOTER //
// checkInOut.vue?900de71e